import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import { useApi } from '@fortem-monorepo/react-spa'

export const useInternalUser = () => {
  const api = useApi()

  const query = useQuery({
    queryKey: ['account', 'details'],
    queryFn: () => api.account.getUserDetails(),
    retry: 5,
  })

  const internalUser = useMemo(() => {
    return query.data?.user ?? null
  }, [query.data])

  const permissions = useMemo(() => {
    return query.data?.permissions ?? []
  }, [query.data])

  return {
    query,
    internalUser,
    permissions,
  }
}
